import React from 'react';
import ReactDOM, { hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const initialData = window.__INITIAL_DATA__;
const initialSeo = window.__INITIAL_SEO__;
const initialGlobalSchema = window.__INITIAL_GLOBAL_SCHEMA__;

// const root = ReactDOM.createRoot(document.getElementById('root'));
hydrateRoot(
  document.getElementById("root"),
  <BrowserRouter>
    <HelmetProvider>
      <App
        initialData={initialData}
        initialSeo={initialSeo}
        initialGlobalSchema={initialGlobalSchema}
      />
    </HelmetProvider>
  </BrowserRouter>
);